﻿define('app-TravelPortal/login/settings',[],function () {
    return {
        container: '#loginContainer',
        dobContainer: '#login .date-input-group',
        dobValidationMessage: '#dobValidationMessage',
        formFields: {
            bookingNumber: "#BookingNumber",
            lastName: "#LastName",
            day: "#ddlDay",
            month: "#ddlMonth",
            year: "#ddlYear",
            dateOfBirth: "#DateOfBirth"
        }
    }
});
